module.exports = __webpack_public_path__ + "img/contact-dashboard.e54eaf7b.jpeg";